var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.latestError)?_c('v-app-bar',{attrs:{"fixed":"","app":"","prominent":"","height":"100"}},[_c('alert',{attrs:{"error":_vm.latestError},on:{"close":_vm.removeLatestError}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }